import { useLayoutEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/storeConfig";
import { getMemberListThunk } from "../../../redux/thunk/memberThunk";

type ModalName = "CREATE_TEAM";

export const useTeamManagement = () => {
  const [modalName, setModalName] = useState<ModalName | null>(null);
  const dispatch = useAppDispatch();
  const { adcompanyid } = useAppSelector((state) => state.userInfo);

  const openModal = (name: ModalName) => {
    setModalName(name);
  };

  const closeModal = () => {
    setModalName(null);
  };

  useLayoutEffect(() => {
    if (adcompanyid) {
      dispatch(
        getMemberListThunk({
          payload: {
            urcompanyid: adcompanyid,
          },
        })
      );
    }
  }, [adcompanyid, dispatch]);

  return {
    modalName,
    openModal,
    closeModal,
  };
};
